import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getContent, IContentItem, IMiniGame} from "../../../../../data/data";
import {type} from "os";
import HighlightText from "../../../../common/highlight-text/HighlightText";

interface OutroProps
{
    energy: number;
    game_data: IMiniGame;
}

import './Outro.scss';
import {getMiniGameData} from '../../../../../store/reducers/mini-game/miniGame';


class Outro extends React.Component<OutroProps, null>
{
    constructor(public props: OutroProps)
    {
        super(props);
    }


    render()
    {
        const {energy, game_data} = this.props;

        // return <span>
        //
        //     <h3>mini game outro</h3>
        //
        //     <h4>{title}</h4>
        //     <p>{description}</p>
        //     <p>you scored {this.props.energy}</p>
        //
        // </span>;


        return <div styleName={'event-outro'}>

            <div styleName={'header'}>

                <img
                    styleName={'image'}
                    src={`./img/game/event-details/energy-spike@3x.png`} />

            </div>

            <div styleName={'text-column'}>

                <HighlightText type={'red'}>Time's up!</HighlightText>

                <h4 styleName={'headline'}>you generated {energy}% of the back-up electricity needed!</h4>

                <p styleName={'body-copy'}>{energy > 60 ? game_data.results[0] : game_data.results[1]}</p>

            </div>

        </div>;
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        game_data: getMiniGameData(state),
        // content: getContent('mini-game-outro')
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Outro);



// WEBPACK FOOTER //
// ./src/ts/app/screens/mini-game/modals/outro/Outro.tsx